export enum ColumnTypes {
  BOOLEAN = 0,
  INTEGER = 1,
  STRING = 2,
  DATE = 3,
  DATETIME = 4,
  CURRENCY = 5,
  DOUBLE = 6,
  COMPLEX = 7, // Array de strings
  MILHAR = 8,
  MOEDA = 9,
  CUSTOM = 10,
  ENUM = 11
  }
  export class ColumnModel {
    title: string;
    name: string;
    style: string[];
    customFields: string[];
    filter: string;
    columnSelect: string;
    orderDir: string;
    type: ColumnTypes = ColumnTypes.STRING;
    enumValues: Array<IdNumberAndDescription>;
    complexFunction: any;
    orderField: string;
    transformCustomValue?: MxTransformCustomValue;
    searchInComplexBy?:string;
  
  
    constructor($title?: string, $name?: string) {
      this.title = $title || '';
      this.name = $name || '';
    }
  }
  
  export declare type MxTransformCustomValue = (rowData?: any) => string;
  
  export interface IdNumberAndDescription {
    id: number;
    description: string;
  }
  
